import React from "react";
import './Button.css';

const Button = () => {

    return(
        <div>
            <div className='button'>
                <div className='line'></div> 
                <div className='line'></div>
                <div className='line'></div>
                <div className='line'></div>
                <div className='line'></div>
                <div className='line'></div>
                <span>Saznaj vise</span>
            </div>
        </div>
    );

}

export default Button;